export class ControlDto {

        controlId;
        number;
        dateFrom;
        dateTo;
        dateStart;
        dateEnd;
        isFollowUp;
        followUpStatus;
        followUpNote;
        controlStatus;
        creationPerson;
        creationDate;
        listValidated;
        modificationPerson;
        modificationDate;
        program;
        project;
        dictionaryEntries;
        controllers;
        teamLeader;
        questionList;
        controlledParties=[];
        controlPlaces=[];
        paymentClaims=[];
        orders=[];
        answers=[];
        answerBlockStatus=[];
        postControlDocuments;
        blockId;
    }
